import { render } from "./ButtonNr2.vue?vue&type=template&id=7edc796b&scoped=true"
import script from "./ButtonNr2.vue?vue&type=script&lang=js"
export * from "./ButtonNr2.vue?vue&type=script&lang=js"

import "./ButtonNr2.vue?vue&type=style&index=0&id=7edc796b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edc796b"]])

export default __exports__